import Vue from 'vue'
import VueRouter from 'vue-router'
//路由导航冗余报错（路由重复）
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

// 创建路由
export default new VueRouter({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "currentActive",
  routes: [
    {
      path: '',
      component: () => import('@/components/index'),
      redirect: '/',
      children: [
        {
          path: '/index',
          name: 'Index',
          component: () => import('@/components/index'),
        },
        {
          path: '/',
          name: 'Home',
          component: () => import('@/components/pages/home/home.vue'),
        },
        {
          path: '/product',
          name: 'Product',
          component: () => import('@/components/pages/product/productnew'),
        },
        {
          path: '/large/:id',
          name: 'Large',
          component: () => import('@/components/pages/product/large'),
        },
        {
          path: '/product/:id',
          name: 'Producthr',
          component: () => import('@/components/pages/product/producthr'),
        },
        {
          path: '/product/outsource',
          name: 'Productoutsource',
          component: () => import('@/components/pages/product/productoutsource'),
        },
        {
          path: '/product/wecom',
          name: 'Productwecom',
          component: () => import('@/components/pages/product/productwecom'),
        },
        {
          path: '/product/ecall',
          name: 'Productecall',
          component: () => import('@/components/pages/product/productecall'),
        },
        {
          path: '/product/ordering',
          name: 'Productordering',
          component: () => import('@/components/pages/product/productordering'),
        },
        {
          path: '/price',
          name: 'price',
          component: () => import('@/components/pages/price/price'),
        },
        {
          path: '/learning',
          name: 'Learining',
          component: () => import('@/components/pages/learn/learning'),
        },
        {
          path: '/about',
          name: 'About',
          component: () => import('@/components/pages/about'),
        },
        {
          path: '/media',
          name: 'media',
          component: () => import('@/components/pages/about/media'),
        },
        {
          path: '/coverage/1',
          name: '/coverage/1',
          component: () => import('@/components/article/one/one')
        },
        {
          path: '/coverage/2',
          name: '/coverage/2',
          component: () => import('@/components/article/two/two')
        },
        {
          path: '/coverage/3',
          name: '/coverage/3',
          component: () => import('@/components/article/three/three')
        },
        {
          path: '/coverage/4',
          name: '/coverage/4',
          component: () => import('@/components/article/four/four')
        },
        {
          path: '/coverage/5',
          name: '/coverage/5',
          component: () => import('@/components/article/one/oneless')
        },
        {
          path: '/coverage/6',
          name: '/coverage/6',
          component: () => import('@/components/article/five/five')
        },
        {
          path: '/coverage/7',
          name: '/coverage/7',
          component: () => import('@/components/article/seven/seven')
        },
      ]
    },

    { path: '*', redirect: '/' },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js